import React, { useState } from 'react';
import { Grid } from '@mui/material';
import DetailsCard from './DetailsCard';
import InlineNomineeForm from './InlineNomineeForm';
import InlineBeneficiaryForm from './InlineBeneficiaryForm';
import { add, set } from 'lodash';

const StaffBeneficiaryNominee = ({ 
    staffData, 
    onSave,
    relations = []
   
}) => {
    const [isAddingNominee, setIsAddingNominee] = useState(false);
    const [addedBeneficiary, setAddedBeneficiary] = useState({});
    const onSaveBeneficiary = async (beneficiaryData) => {
        setAddedBeneficiary(beneficiaryData);
        setIsAddingNominee(true);
    }
    const handleDeleteBeneficiary = () => {
        setIsAddingNominee(false);
        setAddedBeneficiary({});
    }
    const onSaveNominee = async (data) => {
        if(onSave){
            onSave(addedBeneficiary, data ,staffData);
        }
    }
    const beneficiaryDetails = isAddingNominee ? [
        { label: 'Name', value: addedBeneficiary.full_name },
        { label: 'D.O.B', value: addedBeneficiary.dob },
        { label: 'Age', value: `${addedBeneficiary.age}y`},
        { label: 'Gender', value: addedBeneficiary.gender },
        { label: 'Mobile No.', value: addedBeneficiary.phone_number },
    ] : [];


    return (
        <>
        {!isAddingNominee && (    
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <InlineBeneficiaryForm
                        staffData={staffData}
                        onSave={onSaveBeneficiary}
                        relations={relations}
                    />
                </Grid>
            </Grid>
            )}
         {isAddingNominee && (
            <>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                            <DetailsCard
                                title="Beneficiary Details"
                                isDeletable={true}
                                onDelete={handleDeleteBeneficiary}
                                details={beneficiaryDetails}
                            />
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ display: { xs: 'none', md: 'flex'} }}></Grid>
                    <Grid item xs={12} md={6}>
                        <Grid item xs={12} md={6} sx={{ display: {xs: 'none', md: 'flex'} }}></Grid>
                        <Grid item xs={12} md={6}>
                            <InlineNomineeForm
                                staffData={staffData}
                                onSave={onSaveNominee}
                                relations={relations}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </>
         )}
      
        </>
    );
};

export default StaffBeneficiaryNominee;